import styled from 'styled-components';

import { borderGradientStyle } from '@sorare/core/src/style/utils';

export const ManagerIdRoot = styled.div`
  position: relative;
  padding: 1px;
  background-color: var(--c-nd-100-opaque);

  --border-size: 1px;
  --border-gradient: var(--border);
  ${borderGradientStyle}
`;
